import { render, staticRenderFns } from "./site-configurator.vue?vue&type=template&id=0f4b0bcc&scoped=true"
import script from "./site-configurator.vue?vue&type=script&lang=js"
export * from "./site-configurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b0bcc",
  null
  
)

export default component.exports